"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var file_saver_1 = require("./file-saver");
/**
 * Factory for getting FileSaver instance
 *
 * Created by Hayk.Andriasyan on 9/15/2017.
 */
var FileSaverFactory = /** @class */ (function () {
    function FileSaverFactory() {
    }
    FileSaverFactory.getFileSaver = function () {
        return new file_saver_1.FileSaver();
    };
    return FileSaverFactory;
}());
exports.FileSaverFactory = FileSaverFactory;
//# sourceMappingURL=file-saver-factory.js.map